import './button.css';

export interface IButton {
  label: string,
  className?: string,
  onClickHandler?: () => void,
  args?: string
}
/**
 * Primary UI component for user interaction
 *
 */
export const Button: React.FC<IButton> = ({ label, className, onClickHandler, ...args }) => {
  return (
    <button
      type="button"
      className={className}
      onClick={onClickHandler}
      { ...args }
    >
      {label}
    </button>
  );
}

Button.defaultProps = {
  label: 'Button',
  className: 'default-button',
  onClickHandler: () => { console.log("in default clickHandler"); },
};
